import type {
  DeleteUploadMutation,
  DeleteUploadMutationVariables,
} from '../generated';

import { gql, TypedDocumentNode } from '@apollo/client';

export const DELETE_UPLOAD: TypedDocumentNode<
  DeleteUploadMutation,
  DeleteUploadMutationVariables
> = gql`
  mutation DeleteUpload($id: ID!) {
    deleteUpload(id: $id)
  }
`;
